import { useMemo } from "react";
import debounce from "lodash.debounce";

export function useDebounce(fn, time = 700) {
  return useMemo(() => {
    return debounce(fn, time);
  }, [fn, time]);
}
